export const sizes = {
  sm: "tabs-sm",
  md: "tabs-md",
  lg: "tabs-lg",
};
